
<template>
  <div
    id="btnDashboardUpload"
    class="import-xml-widget"
    @click="setUploadModalVisible(true)"
  >
    <div
      v-if="content.icon"
      class="import-xml-widget__icon"
    >
      <svg-loader
        class="icon-routine"
        :src="'/static/images/icon-dashboard-' + content.icon + '.svg'"
      />
    </div>
    <div
      class="import-xml-widget__item"
      :class="{'import-xml-widget__description--bigger': content.sizeBig}"
    >
      <h2>{{ content.text }}</h2>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ImportXml',
  props: {
    content: {
      icon: {
        type: String
      },
      number: {
        type: String
      },
      text: {
        type: String
      },
      color: {
        type: String
      },
      sizeSmall: {
        type: Boolean,
        default: false
      },
      sizeBig: {
        type: Boolean,
        default: false
      }
    }
  },
  data () {
    return {
      items: []
    }
  },
  methods: {
    ...mapActions(['setUploadModalVisible'])
  }
}
</script>
<style lang="scss" scoped>
.import-xml-widget {
  background-color: rgba(217, 217, 217, 0.3);
  padding: 11px;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;

  &__icon {
    width: 37%;
    .icon-routine {
      width: 54px !important;
      height: 44px !important;
      margin: auto;
    }
    &--smaller {
      width: 10%;
    }
  }

  &__item {
    display: flex;
    align-items: center;

    h2 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      text-align: right;
      text-transform: uppercase;
      color: #E2245A;
    }
  }

  &:hover {
    background-color: #E2245A;

    color: white !important;
    .import-xml-widget__item {
      h2 {
        color: white !important;
      }
    }
  }
}
</style>
